import axiosNest from '../../api/axiosNest';

/**
 * Zapis poświadczenia do magazynu (`PUT /credentials/:id`, API
 * `credentials.controller.ts` — identyfikator w ścieżce jest ignorowany,
 * wiersz wskazują system, pole i spółka). Odpowiedź nie niesie wartości.
 */
export interface CredentialWrite {
  system: string;
  field: string;
  value: string;
  /** `null` = wspólne dla instancji. */
  companyId: number | null;
  description?: string | null;
}

export async function saveCredential(input: CredentialWrite): Promise<void> {
  await axiosNest.put('/credentials/new', input);
}

/** Login i hasło serwera SFTP importu TMS — klucze w magazynie (dane, nie tłumaczymy). */
export const VIA_SFTP = {
  SYSTEM: 'via-sftp',
  LOGIN: 'login',
  PASSWORD: 'password',
} as const;
